import { Box, Grid2, Paper, Typography } from "@mui/material";
import styled from "@emotion/styled";
import React from "react";
import { useTheme } from "@emotion/react";
import { ShortBank } from "../utils";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export interface BicSelectProps {
  banks: ShortBank[];
  onSelect?: (bank: ShortBank) => void;
  className?: string;
}

export const BicSelect = ({ banks, onSelect, className }: BicSelectProps) => {
  const theme = useTheme();

  return (
    <Container data-testid="bic-select" className={className}>
      <Grid2 container rowSpacing={2.5} columnSpacing={4} width="100%">
        {banks.map((bank, index) => (
          <Grid2
            key={bank.bic ?? bank.id ?? index}
            size={{
              sm: 6,
              md: 4,
              xs: 12,
            }}
          >
            <Paper
              sx={{
                height: "48px",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: theme.palette.action.hover,
                },
              }}
              data-testid="bic-button"
              onClick={() => onSelect?.(bank)}
            >
              <Box p={3} display="flex" alignItems="center">
                <Typography>{bank.bic}</Typography>
              </Box>
            </Paper>
          </Grid2>
        ))}
      </Grid2>
    </Container>
  );
};
